import React from "react";
import { PageHeader } from "./PageHeader";
import ProgramPng from "../img/program-v1.png"

export const ProgramRamowy = props => {
  return (
    <React.Fragment>
      <PageHeader title="Program" />
      <div className="content-wrapper">
        <div className="main-content program">
            <div className="row">
                <h2>Ramowy program Zjazdu</h2>
                <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                    Program ramowy w języku polskim można pobrać w formacie PDF klikając przycisk pobierz:
                    <br/>
                    <a className="btn btn-primary" target="_blank" rel="noopener noreferrer" href="http://www.45zfp.uj.edu.pl/program-ramowy-pl.pdf">POBIERZ PROGRAM</a>
                </div>
                <br/><br/>
                <br/><br/>
                <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                     English version of the framework program can be downloaded in PDF format by clicking:
                    <br/>
                    <a className="btn btn-primary" target="_blank" rel="noopener noreferrer" href="http://www.45zfp.uj.edu.pl/program-ramowy-en.pdf">DOWNLOAD PROGRAM</a>
                </div>
                <br/><br/>
                <br/><br/>
                <div className="col-xs-12 col-sm-12 col-md-12">
                    <a target="_blank" rel="noopener noreferrer" href="http://www.45zfp.uj.edu.pl/program-ramowy-pl.pdf">
                        <img width="100%" src={ProgramPng} alt="Obraz programu ramowego" />
                    </a>
                </div>
            </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ProgramRamowy.propTypes = {};
